import axios from "axios";
import {formatDate} from "devextreme/localization";


export default {
    version: '10050',
    language: 'de',

    session_token: null,
    menu: null,
    userIdent: null,
    userId: null,

    host: "https://hhs.halvar-it.de/",
    apiHost: "https://hhs.halvar-it.de/api/",

    // host: "http://hhs/",
    // apiHost: "http://hhs/api/",

    sendRequest(className, id, attr, value) {
        return new Promise((resolve) => {
            return axios.post(this.apiHost + "validation", {
                className: className,
                id: id,
                attribute: attr,
                value: value
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.session_token,
                    'last-update-ts': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
                }
            }).then(response => {
                if (response.status === 200) {
                    resolve(true);
                }
            }).catch(() => {
                resolve(false);
            });
        });
    },

    updateHeight(component) {
        if (component)
            component.instance.option("height", (window.innerHeight) - 76);
        else
            return window.innerHeight - 44;
    }

};
